import { type EmailVariable } from '../emailTemplateTypes'

const PLACEHOLDER = /\{\{\s*([a-z_][a-z0-9_]*)\s*\}\}/g

const jinjaString = (value: string): string => `'${value.replace(/\\/g, '\\\\').replace(/'/g, "\\'")}'`

export const applyFallbacks = (text: string, variables: EmailVariable[]): string => {
  const byName = new Map(variables.map((variable) => [variable.name, variable]))
  return text.replace(PLACEHOLDER, (whole, name: string) => {
    const fallback = byName.get(name)?.fallback
    return fallback === undefined ? whole : `{{ ${name} | default(${jinjaString(fallback)}, true) }}`
  })
}
